import React, { FC } from "react";

import styles from "./index.module.css";

type CircleCounterProps = {
  limit: number;
  offset: number;
};

const CircleCounter: FC<CircleCounterProps> = (props) => {
  const { limit, offset } = props;
  const fillCircleValue = (offset / limit) * 100;

  // Counts left time in percentage. If more than 80% left - green. 40-80 - yellow, below 40 - red
  const getCircleColorClass = (fillValue: number) => {
    if (fillValue <= 80) return styles.circleSuccess;
    if (fillValue <= 40) return styles.circleDanger;
    return styles.circleError;
  };

  return (
    <div className={styles.container}>
      <svg
        className={styles.svg}
        id="svg"
        width="24"
        height="24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className={`${styles.circle} ${getCircleColorClass(fillCircleValue)}`}
          strokeWidth={2}
          r="11"
          cx="12"
          cy="12"
          strokeDasharray="85"
          strokeDashoffset={fillCircleValue}
        />
      </svg>
      <span className={styles.counterText}>{limit - offset}</span>
    </div>
  );
};

export default CircleCounter;
